// packages/world-model/src/traits/lockable/index.ts

export * from './lockableTrait';
export * from './lockableBehavior';